import { ChangeDetectionStrategy, Component, effect, inject, OnInit, signal } from '@angular/core';
import { forkJoin, of } from 'rxjs';

import { BaseController } from '../../../core/abstractions/base.controller';
import { UserModel } from '../../../models/user.model';
import { MetaResource } from '../../../services/resources/meta.resource';
import { RolesResource } from '../../../services/resources/roles.resource';
import { UsersResource } from '../../../services/resources/users.resource';

@Component({
    selector: 'sl-users-view',
    templateUrl: './users-view.component.html',
    styleUrls: ['./users-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UsersViewComponent extends BaseController<UserModel> implements OnInit {
    languageName: string;
    roleName: string;
    readonly isLoadingResources = signal(true);

    protected override readonly _entityResource = inject(UsersResource);

    private readonly metaResource = inject(MetaResource);
    private readonly rolesResource = inject(RolesResource);

    constructor() {
        super();

        effect(
            () => {
                if (!this.isLoading() && !!this.recordSummary()) {
                    const summary = this.recordSummary()!;

                    forkJoin({
                        languages: summary.languageId ? this.metaResource.getLanguages() : of(undefined),
                        roles: summary.roleId ? this.rolesResource.getAll() : of(undefined)
                    }).subscribe(resp => {
                        if (!!resp.languages) {
                            this.languageName = resp.languages.value.find(l => l.id === summary.languageId)?.label ?? '';
                        }

                        if (!!resp.roles) {
                            this.roleName = resp.roles.value.find(role => Number(role.id) === summary.roleId)?.name ?? '';
                        }

                        this.isLoadingResources.set(false);
                    });
                }
            },
            { allowSignalWrites: true }
        );
    }
}
